import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MANIFESTO } from "@/data/content";

function Chapter({ item, index }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "start center"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [70, 0]);
  const opacity = useTransform(scrollYProgress, [0, 1], [0.15, 1]);

  return (
    <motion.article
      ref={ref}
      style={{ y, opacity }}
      data-testid={`manifesto-${index}`}
      className="grid grid-cols-1 gap-6 border-t border-white/10 py-14 md:grid-cols-[160px_1fr] md:gap-12 md:py-20"
    >
      <div className="font-display text-6xl md:text-7xl leading-none text-[#10b981]">
        {item.n}
      </div>
      <div className="max-w-3xl">
        <h3 className="text-3xl md:text-5xl font-extrabold tracking-tight text-[#f2f0e6]">
          {item.title}
        </h3>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-[#b9b6a8]">
          {item.body}
        </p>
      </div>
    </motion.article>
  );
}

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative z-30 bg-[#050505] px-6 py-28 md:px-10 md:py-40"
    >
      <div className="mx-auto max-w-[1500px]">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-10 flex items-center gap-4 text-xs uppercase tracking-[0.35em] text-[#7c7a72]"
        >
          <span className="h-px w-10 bg-[#10b981]" />
          The Manifesto
        </motion.div>
        <div>
          {MANIFESTO.map((m, i) => (
            <Chapter key={m.n} item={m} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
